export default "__VITE_ASSET__Fhtfgs_v__"